var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 98,
    viewBox: "0 0 291 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -67.8693,
    y: -67.8693,
    width: 426.739,
    height: 233.739
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(33.93px)",
      clipPath: "url(#bgblur_0_5953_7121_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 67.8693,
    y: 98,
    width: 98,
    height: 291,
    rx: 30,
    transform: "rotate(-90 0 98)",
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 30,
    width: 203,
    height: 39,
    fill: "url(#pattern0_5953_7121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5953_7121_clip_path",
    transform: "translate(67.8693 67.8693)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 98,
    width: 98,
    height: 291,
    rx: 30,
    transform: "rotate(-90 0 98)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_5953_7121",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5953_7121",
    transform: "matrix(0.00156006 0 0 0.00812032 0 -0.0481219)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5953_7121",
    width: 641,
    height: 135,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group (3).4ae4ab2c217f8c4bff9b72384f7a98fc.svg";
export { ForwardRef as ReactComponent };